import script from "./GradesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GradesSection.vue?vue&type=script&setup=true&lang=js"

import "./GradesSection.vue?vue&type=style&index=0&id=2ac4eb6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac4eb6b"]])

export default __exports__